import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Column, Row, TextButton, Typography } from 'seagull';
import { NotificationEditField } from '~/components/NotificationEditField/NotificationEditField';
import styles from '../AdHocBillModal.module.scss';
const AD_HOC_EXCLUDED_CATEGORIES = [
    'Agreement'
];
export const EmailContentSection = (param)=>{
    let { testIds, texts, defaultEmailSubject, defaultEmailContent } = param;
    const { control, setValue, clearErrors, formState: { errors } } = useFormContext();
    const subjectError = errors.emailSubject != null;
    const contentError = errors.emailContent != null;
    const revertSubject = ()=>{
        setValue('emailSubject', defaultEmailSubject);
        clearErrors('emailSubject');
    };
    const revertContent = ()=>{
        setValue('emailContent', defaultEmailContent);
        clearErrors('emailContent');
    };
    return /*#__PURE__*/ _jsxs(Box, {
        className: styles.section,
        testId: testIds.Section(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                weight: "normal",
                className: styles.sectionTitle,
                children: texts.sectionTitle()
            }),
            /*#__PURE__*/ _jsxs(Column, {
                children: [
                    /*#__PURE__*/ _jsx(Controller, {
                        control: control,
                        name: "emailSubject",
                        render: (renderProps)=>/*#__PURE__*/ _jsx(NotificationEditField, {
                                bi: {
                                    name: 'email_subject'
                                },
                                disableCustomTags: true,
                                excludeCategories: AD_HOC_EXCLUDED_CATEGORIES,
                                label: texts.subjectLabel(),
                                testId: testIds.Subject(),
                                value: renderProps.field.value,
                                onChange: (next)=>{
                                    renderProps.field.onChange(next);
                                    if (next.trim().length > 0) clearErrors('emailSubject');
                                },
                                error: subjectError
                            })
                    }),
                    subjectError && /*#__PURE__*/ _jsxs(Row, {
                        gap: 4,
                        alignItems: "center",
                        className: styles.fieldError,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph3",
                                skin: "error",
                                testId: testIds.SubjectError(),
                                children: texts.subjectRequired()
                            }),
                            /*#__PURE__*/ _jsx(TextButton, {
                                bi: {
                                    name: 'revert_email_subject_to_default'
                                },
                                variant: "paragraph3",
                                skin: "error",
                                testId: testIds.RevertSubject(),
                                onClick: revertSubject,
                                children: texts.revertToDefault()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Column, {
                children: [
                    /*#__PURE__*/ _jsx(Controller, {
                        control: control,
                        name: "emailContent",
                        render: (renderProps)=>/*#__PURE__*/ _jsx(NotificationEditField, {
                                bi: {
                                    name: 'email_content'
                                },
                                disableCustomTags: true,
                                excludeCategories: AD_HOC_EXCLUDED_CATEGORIES,
                                multiline: true,
                                minRows: 6,
                                label: texts.contentLabel(),
                                testId: testIds.Content(),
                                value: renderProps.field.value,
                                onChange: (next)=>{
                                    renderProps.field.onChange(next);
                                    if (next.trim().length > 0) clearErrors('emailContent');
                                },
                                error: contentError,
                                adornmentClassName: styles.emailContentAdornment
                            })
                    }),
                    contentError && /*#__PURE__*/ _jsxs(Row, {
                        gap: 4,
                        alignItems: "center",
                        className: styles.fieldError,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph3",
                                skin: "error",
                                testId: testIds.ContentError(),
                                children: texts.contentRequired()
                            }),
                            /*#__PURE__*/ _jsx(TextButton, {
                                bi: {
                                    name: 'revert_email_content_to_default'
                                },
                                variant: "paragraph3",
                                skin: "error",
                                testId: testIds.RevertContent(),
                                onClick: revertContent,
                                children: texts.revertToDefault()
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
